import React from 'react';

import * as S from './styles';

const Slide8: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Content>
        <S.SubtitleMobile>
          Casaco, R$ 3.490, e corset, R$ 980, ambos Collab Felipe Fanaia com
          UMS-458.
        </S.SubtitleMobile>
      </S.Content>
    </S.Container>
  );
};

export { Slide8 };
